export const formatCurrency = (price: number, digits: boolean = true) =>
    new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: digits ? 2 : 0,
    }).format(price);
